import React from "react";
import PropertyDetails from ".";
import { useLocation, useParams } from "react-router-dom";
import { useInvestorPropertyDetail } from "../../../hooks/react-query/investor/useInvestorPropertyDetail";

export default function PropertyDetailMain() {
  const { propertyId }: any = useParams();
  const location = useLocation();
  const internalPattern = /^\/internal\/[a-zA-Z0-9]+$/i;
  const { data: propertyDetail } = useInvestorPropertyDetail(propertyId, "internal-investor");

  return (
    <>
      <PropertyDetails
        propertyId={
          internalPattern.test(location.pathname)
            ? propertyDetail?.id
            : propertyId
        }
      />
    </>
  );
}
